export default "__VITE_ASSET__RyHLZLnd__"